import { useAccountState } from 'contexts/account/account-context';
import { useGet } from 'hooks/use-get';
import { getFolderById } from 'views/file-sharing/api/file-sharing';

// An example of a hook wrapping an api call. We can set default behavior here and reuse the same hook by just changing the parameter.
// If more needs to be used (For instance: some additional behavior in the onSuccess), then useGet can be called directly in a file.

export const useFolder = ({ selectedFolderId }: { selectedFolderId: string }) => {
  const { account } = useAccountState();

  return useGet(
    ['getFolderById', account.company?.companyId, selectedFolderId],
    ({ queryKey }) => getFolderById(String(queryKey[1]), String(queryKey[2])),
    {
      staleTime: 30000, // 30 second stale time
    }
  );
};
